var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-menu',{attrs:{"left":!_vm.AppRtl,"offset-y":"","tile":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-translate")])],1)]}}])},[_c('app-language-list',{attrs:{"center":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }